import React from 'react';
import { Box, Button, Typography } from '@mui/material';

import { AdminLegendVariant, ProfessionalReplacementTypes } from '@pharmaplan/common';
import styles from './styles';
import legendStyles from '../../AdminLegend/styles';
import strings from '../../../../../localization';
import useAdminLegendNavigation from '../../../../../hooks/AdminLegend/useAdminLegendNavigation';

export interface IAdminSplitLegendItem {
  labelKey: 'pharm' | 'tech' | 'booked' | 'grand';
  variant: `${AdminLegendVariant}`;
  replacementType: ProfessionalReplacementTypes | null;
  totalHrs: number;
  totalCount: number;
  isRow: boolean;
}

const AdminSplitLegendItem = ({
  labelKey,
  variant,
  replacementType,
  totalHrs,
  totalCount,
  isRow,
}: IAdminSplitLegendItem) => {
  const isTotalVariant = variant === AdminLegendVariant.total;
  const { handleNavigateToReport } = useAdminLegendNavigation();

  const handleClick = () => {
    handleNavigateToReport(variant, replacementType);
  };

  return (
    <Box
      component={Button}
      variant="text"
      disabled={isTotalVariant}
      onClick={handleClick}
      sx={[styles.container, !isTotalVariant && legendStyles.container(variant)]}
    >
      <Box sx={styles.textContainer}>
        <Typography
          noWrap
          sx={[legendStyles.legendTitle, isRow && legendStyles.rowLegendText]}
        >
          {strings[labelKey]}
        </Typography>
        <Box
          sx={[
            legendStyles.legendTotalHrs,
            isRow && legendStyles.rowLegendText,
            isRow && styles.rowTotalHrs,
            legendStyles.totalHrsCountColor(variant),
          ]}
        >
          {strings.formatString(strings.hoursWorked, Math.trunc(totalHrs))}
        </Box>
      </Box>
      <Box
        sx={[
          legendStyles.legendTotalCount,
          legendStyles.rowLegendTotalCount,
          legendStyles.totalHrsCountColor(variant),
        ]}
      >
        {totalCount}
      </Box>
    </Box>
  );
};

export default AdminSplitLegendItem;
